import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import cartMini from 'assets/cart-mini.svg';

const ResumenTicket = (props) => {
  const { resumen, disabled, sticky } = props;
  const disabledClass = disabled ? 'disabled' : '';
  const stickyClass = sticky ? 'sticky-resumen' : 'opacity-70';

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen')[0];
      const elm = document.querySelector('#root');

      if (element !== undefined && elm !== undefined) {
        if (window.scrollY <= 400) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
          element.classList.remove('sticky');
        }

        if ((window.innerHeight + window.scrollY) >= (elm.offsetHeight - 285)) {
          element.classList.remove('active');
          element.classList.add('sticky');
        }
      }
    });
  };

  function add(accumulator, a) {
    return accumulator + a;
  }

  const sumTotalPoints = () => {
    const arrayPoints = [];
    resumen.map((item) => {
      return arrayPoints.push(Number(item.points));
    });
    const sum = arrayPoints.reduce(add, 0);
    return sum.toLocaleString('es-MX');
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <div className={`${stickyClass} bg-color-westar p-15 mt-30 d-none d-lg-block d-xl-block ${disabledClass}`}>
      <img src={cartMini} alt="shopping-cart-icon" className="py-15" />
      <h3 className="text-tangaroa">Resumen de tu pedido</h3>
      <h3 className="pt-30 pb-15 text-tangaroa">Experiencias</h3>
      {
        resumen.map((ticket, index) => {
          return (
            /* eslint-disable */
            <Row className="gift-label my-15" key={index}>
              <Col xs={8} lg={8}>
                <p className="ft-12 text-tangaroa">
                  {ticket.isGift === true ? (
                    <i className="fas fa-gift mr-2" />
                  ) : '' }
                  {ticket.title}
                </p>
              </Col>
              <Col xs={4} lg={4} className="text-right">
                <b className="text-tangaroa">
                  {(Number(ticket.points)).toLocaleString('es-MX')}
                </b>
              </Col>
            </Row>
          );
        })
      }
      <Row className="pt-30">
        <Col xs={8} lg={8}>
          <h5 className="ft-14 text-dark-blue">
            <b>Total de Puntos Aeroméxico Rewards</b>
          </h5>
        </Col>
        <Col xs={4} lg={4} className="ft-14 text-right text-primary">
          <b>
            { sumTotalPoints() }
          </b>
        </Col>
      </Row>
    </div>
  );
};

ResumenTicket.defaultProps = {
  disabled: false,
  sticky: true,
};

ResumenTicket.propTypes = {
  resumen: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  sticky: PropTypes.bool,
};

export default ResumenTicket;
